module.exports = __webpack_public_path__ + "media/images/offer-empty-42fc3f8b8437a97bcbf67a8ca7fde1e6.png";